<script>
import Vue from 'vue'
import CandelaComponent from '@/components/CandelaComponent'

export default {
  extends: CandelaComponent,
  data() {
    return {
      active: {},
      annotation_list: []
    }
  },
  computed: {
    annotated_text() {
      this.update_annotations()
      const chars = this.text ? this.text.split('') : []
      Object.entries(this.annotations).forEach((e, i) => {
        if(this.active[e[0]]) {
          const annotations = e[1]
          const color = this.get_annotation_color(e[0])
          const span = `<span class='entity'
            style='background-color: ${color};
            color: white; padding: 0.2em; border-radius: 0.5em;'>`
          annotations.indices.forEach(p => {
            const start_char = chars[p[0]]
            const end_char = chars[p[1]-1]
            chars[p[0]] = `${span}${start_char}`
            chars[p[1]-1] = `${end_char}</span>`
          })
        }
      })
      return chars.join('')
    }
  },
  methods: {
    get_annotation_color(k) {
      const idx = this.annotation_list.indexOf(k)
      return this.settings.annotation_colors.value(idx)
    },
    on_annotation_click(a) {
      if(this.active[a] === undefined) {
        Vue.set(this.active, a, true)
      } else {
        Vue.set(this.active, a, !this.active[a])
      }
    },
    update_annotations() {
      // Create new annotations
      Object.keys(this.annotations || [])
        .forEach(k => {
          if(this.annotation_list.indexOf(k) < 0) this.annotation_list.push(k)
          if(this.active[k] === undefined) Vue.set(this.active, k, false)
        })
    }
  },
  props: {
    text: {type: String, default: () => ''},
    annotations: {type: Object, default: () => ({})}
  },
  name: 'AnnotatedDoc'
}
</script>
<template>
<div class='candela-component'>
  <v-card-text class='main-container ignore-drag d-flex flex-column'>
    <div class='document-container'>
      <div class='document'>
        <p v-html='annotated_text'/>
      </div>
    </div>
    <p class='mb-0' v-if='annotations.length'>Annotations</p>
    <div class='button-container mt-4'>
      <v-btn v-for='(annotation) in Object.keys(annotations || [])'
        :key='annotation' @click='on_annotation_click(annotation)'
        class='mr-2 mb-2' :dark='active[annotation]'
        small rounded elevation='0' :color='get_annotation_color(annotation)'>
        <v-icon v-if='active[annotation]' left small>fa-check-circle</v-icon>
        {{ annotation }}
        <v-spacer/>
        <v-avatar class='ml-2' size='small' right>
          {{ annotations[annotation].indices.length }}
        </v-avatar>
      </v-btn>
    </div>
  </v-card-text>
</div>
</template>
<style lang='sass' scoped>
.main-container
  .annotation-list
    max-height: 320px
    .annotation
      white-space: nowrap

  .document-container
    max-height: 320px
    margin-bottom: 1em
    overflow-y: auto
    padding-bottom: 0.2em
    border-bottom: 1px solid #ccc
</style>
